import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/CustomModal";
import Storage from "@/app/core/util/Storage";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import BoxItem from "./BoxItem";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { Panel, Tab, Tabs } from "@bumaga/tabs";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import { DateTranslate, DateTranslateSimple, OnlyDateTranslate } from "@/app/core/util/DateTranslater";
import Etiqueta from "../files/Etiqueta";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import JsBarcode from "jsbarcode";
import { PartnerHelper } from "@/app/core/util/helpers/PartnerHelper";
import { CorreiosController } from "@/app/core/base/controllers/CorreiosController";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { Menu } from "@/app/core/config/menu";

export default function DeliveryModal({ show, onHide, deliveryId }) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [docs, setDocs] = useState([]);
    const [schedule, setSchedule] = useState({});
    const [timeline, setTimeline] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show && deliveryId) {
            loadDelivery()
            loadTimeline()
        }
    }, [deliveryId, show])

    async function loadDelivery() {
        setLoading(true);
        await DeliveryController.GetOne(deliveryId, res => {
            if (res.partner == PartnerHelper.Partner.Correios) {
                CorreiosController.CreateRotulo(res.correiosPrePostagemId, resultado => {
                    CorreiosController.RequestRotulo(resultado.idRecibo, doc => {
                        // const blob = b64toBlob(doc.dados, "pdf");

                        const byteCharacters = atob(doc.dados);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });
                        const blobUrl = URL.createObjectURL(blob);

                        setDocs([
                            { name: doc.nome, url: blobUrl }
                        ])
                    })
                })
            } else if (res.partner == PartnerHelper.Partner.Shipsmart) {
                DeliveryController.GetSchedule(res.quotationId, result => {
                    if (result.status == "success") {
                        setSchedule(result.data);
                    } else {
                        toast.error(result.message)
                    }
                }, error => {
                    console.log("Erro schedule", error);
                    console.log("Erro schedule", error.data);
                })
            }
            DeliveryController.ListByStatus(deliveryId, result => {

                console.log("Delivery", res, result);
                setData(res);

            }, error => {
                console.warn("Erro na Delivery", error);

                setData(res);
            })
        })
        await DeliveryController.ListDocs(deliveryId, res => {
            if (res != undefined && res != null) {
                let base = res.data;
                let docs = [];
                // if (res.data.tracking_id) {
                //     setData({ ...data, awb: res.data.tracking_id })
                // }
                for (let s in base.docs) {
                    // if (s != "Invoice" && s != "Declaration") {
                    const item = { ...base.docs[s], name: s };
                    docs.push(item);
                    // }
                }
                setDocs(docs);
            }
        }, error => {
            if (error.status != 204) {
                toast.warn(Translate(Message.ProcessingDocs));
            }
        })
        setLoading(false);
    }

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type));
    }

    async function loadTimeline() {
        TimelineController.GetByDelivery(deliveryId, res => {
            for (let s in res) {
                res[s].time = new Date(res[s].createdAt).getTime();
            }
            res.sort(function (a, b) {
                return a.time - b.time;
            });
            setTimeline(res);
        })
    }

    function save() {
    }

    function processStatus() {
        if (data.id) {
            if (DeliveryHelper().StatusObj.Delivered == data.status) {
                return (
                    <div className="block-title">
                        <i className="si si-check text-info mr-2" /> {Translate(Message.Status.Delivered)}
                    </div>
                )
            } else if (DeliveryHelper().StatusObj.Canceled == data.status) {
                return (
                    <div className="block-title">
                        <i className="si si-close text-info mr-2" /> {Translate(Message.Status.Canceled)}
                        <br />
                        <small>{data.statusDescription}</small>
                    </div>
                )
            } else {

                return (
                    <div className="block-title">
                        <i className="fa fa-shipping-fast text-info mr-2" /> Status: {DeliveryHelper().Status(data.status)}
                        <br />
                        <small>{data.statusDescription}</small>
                    </div>
                )
            }
        }
    }

    function processResponsible(address) {
        if (address && address.name) {
            return (
                <div>
                    <span className="ml-1 mt-1">
                        {Translate(Message.Client)}: {address && address.name}
                    </span>
                    <div className="block block-bordered border-success">
                        <div className="block-header">
                            <div className="block-title row">
                                {/* <div className="col-md-3">
                                    
                                </div> */}
                                <span className="col-md-12 text-left">
                                    <img class="img-avatar img-avatar48 mr-2" src="assets/media/avatars/avatar5.jpg" />{address && address.responsibleName}
                                </span>
                            </div>
                            <div className="block-tools text-right">
                                {address && address.phone && <a className="btn btn-dual" href={`tel:${address.phone}`}><i className="fa fa-phone" /></a>}
                                {address && address.email && <a className="btn btn-dual" href={`mailto:${address.email}`}><i className="si si-envelope-letter" /></a>}
                            </div>
                            <div className="">

                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    function duplicate() {
        window.location = `#/quotation/?deliveryId=${data.id}`;
        // window.open(`#/quotation/?deliveryId=${data.id}`, "_blank");
    }

    function saveSchedule() {
        let error = false;
        if (!data.collectionDate) {
            error = true;
        }
        if (!data.initial_time) {
            error = true;
        }
        if (!data.final_time) {
            error = true;
        }
        if (!data.instruction) {
            error = true;
        }

        if (error) {
            toast.error(Translate(Message.PendingData));
        } else {

            let schedule = {
                shipping: data.quotationId,
                date: data.collectionDate,
                initial_time: data.initial_time + ":00",
                final_time: data.final_time + ":00",
                instruction: data.instruction,
            }
            console.log("Data", schedule);
            DeliveryController.Schedule(schedule, res => {
                toast.success(Translate(Message.Saved));
                TimelineController.Insert({
                    deliveryId: data.id,
                    description: `Usuário registrou uma coleta`,
                    show: true,
                }, result => {
                    loadDelivery();
                })
            })
        }
    }

    function removeSchedule() {
        if (window.confirm(Translate(Message.DeleteConfirm))) {
            console.log("O que rolou", data.cancelationCode, data);
            if (data.cancelationCode == undefined || data.cancelationCode == "selecione") {
                toast.error(Translate(Message.PendingData));
                return;
            }
            DeliveryController.DeleteSchedule(data.quotationId, data.cancelationCode, res => {
                toast.success(Translate(Message.Saved));
                TimelineController.Insert({
                    deliveryId: data.id,
                    description: `Usuário removeu o agendamento de coleta`,
                    show: true,
                }, result => {
                    loadDelivery();
                })
            }, errpr => {
                toast.error("Coleta da Remessa não está em pronta para realizar cancelamento ou o numero enviado não existe");
            })
        }
    }

    return (
        <Modal
            title={Translate(Message.Delivery.Delivery)}
            show={show}
            onHide={onHide}
            isLoading={loading}
            onSubmit={() => save()}>
            <Tabs>
                <Tab>
                    <button className=" btn btn-dual">{Translate(Message.Resume)}</button>
                </Tab>
                <Tab>
                    <button className=" btn btn-dual">{Translate(Message.Tracking)}</button>
                </Tab>
                <Panel>
                    <div className="block-header">
                        <div className="block-title">
                            Serviço: {data && data.description}<br />
                            {data && data.partner == PartnerHelper.Partner.Correios ?
                                <small>
                                    {Translate(Message.DeliveryCode)}: {data && data.correiosPrePostagemId}<br />
                                    {Translate(Message.ObjectCode)}: {data && data.correiosCodigoObjeto}
                                </small>
                                : data && data.partner == PartnerHelper.Partner.TotalExpress ?
                                    <small>
                                        Cód: {data && data.awb != undefined && data.awb != null ? data.awb : data.id}
                                    </small>
                                    :
                                    <small>
                                        Cód: {data && data.awb != undefined && data.awb != null ? data.awb : data.id}
                                    </small>
                            }
                        </div>
                        <div className="block-tools">
                            <button
                                className="btn btn-sm btn-square btn-outline-info js-click-ripple-enabled"
                                onClick={() => duplicate()}>
                                <i className={`far fa-copy mr-2`}></i> {Translate(Message.RepeteDelivery)}
                            </button>
                        </div>
                    </div>
                    <div className="block-content">
                        <ul class="timeline timeline-alt mt-0 mb-0">
                            <li className="timeline-event" style={{ marginTop: -35 }}>
                                <div class="media">
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                            <i className="si si-map" />
                                        </span>
                                    </div>
                                    <div className="block-fx-pop media-body ml-5 mb-3">
                                        <div className="">
                                            <div className="block-title">
                                                {Translate(Message.Origin)} {" "}
                                                <b>{data && data.origin && `${data.origin.number}, ${data.origin.street}, ${data.origin.neighborhood} | ${data.origin.city} - ${data.origin.state}`}</b>
                                                {data && processResponsible(data.origin)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="timeline-event" style={{ marginTop: -50 }}>
                                <div class="media">
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                            <i className="fa fa-flag-checkered" />
                                        </span>
                                    </div>
                                    <div className="block-fx-pop media-body ml-5 mb-3">
                                        <div className="">
                                            <div className="block-title">
                                                {Translate(Message.Destination)} {" "}
                                                <b>{data && data.destination && `${data.destination.number}, ${data.destination.street}, ${data.destination.neighborhood} | ${data.destination.city} - ${data.destination.state}`}</b>
                                                {data && processResponsible(data.destination)}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="block">
                            <div className="block-header mb-0 pb-0">
                                <div className="block-title">
                                    <h2 className="content-heading font-w700">{Translate(Message.Package)} {data && data.boxes && data.boxes.length > 1 ? "s" : ""}</h2>
                                </div>
                            </div>
                            <div className="block-content mt-0 pt-0">
                                {data && data.boxes && data.boxes.map(item => (
                                    <BoxItem presentation={true} data={item} />
                                ))}
                            </div>
                            <div className="block-header mb-0 pb-0">
                                <div className="block-title">
                                    <h2 className="content-heading font-w700">{Translate(Message.Menu.Documents)}</h2>
                                </div>
                            </div>
                            <div className="block-content mt-0 pt-0">
                                {docs && docs.map(item => (
                                    <div className="block block-fx-pop block-bordered border-success mt-1">
                                        <div className="block-header">
                                            <div className="block-title">
                                                <i className="far fa-file-pdf text-success mr-2" /> {item.name}
                                            </div>
                                            <div className="block-tools">
                                                <a className="btn btn-hero-success btn-sm" href={item.url} target="_blank"><i className="si si-cloud-download mr-1" /> Download</a>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* {data && data.id && (data.nfKey == undefined || data.nfKey == "" || data.nfKey == null) && DeliveryHelper().IsNational(data, "BR") != true ? <Declaration delivery={data} /> : ""}
                                {data && data.id && (data.nfKey == undefined || data.nfKey == "" || data.nfKey == null) && DeliveryHelper().IsNational(data, "BR") != true ? <Invoice delivery={data} /> : ""} */}
                                {data && data.id && (data.nfKey == undefined || data.nfKey == "" || data.nfKey == null) && DeliveryHelper().IsNational(data, "BR") == true && data.partner == PartnerHelper.Partner.TotalExpress ? <Etiqueta delivery={data} /> : ""}

                            </div>
                        </div>
                        <div className="block">
                            <div className="block-header mb-0 pb-0">
                                <div className="block-title">
                                    <h2 className="content-heading font-w700">{Translate(Message.Resume)}</h2>
                                </div>
                            </div>
                            <div className="block-content mt-0 pt-0">
                                <table className="table table-hover">
                                    <tbody>
                                        {data && data.collectionInstruction && data.collectionInstruction.length > 0 ?
                                            <tr>
                                                <td>{Translate(Message.CollectionInstructions)}</td>
                                                <td className="text-right">{data && data.collectionInstruction}</td>
                                            </tr>
                                            : ""}
                                        {data && data.collectionInstruction && data.collectionInstruction.length > 0 ?
                                            <tr>
                                                <td>{Translate(Message.CollectionDate)}</td>
                                                <td className="text-right">{data && OnlyDateTranslate(data.collectionDate)}</td>
                                            </tr>
                                            : ""}
                                        <tr>
                                            <td>{Translate(Message.Term)}</td>
                                            <td className="text-right">{data && data.term} {Translate(Message.Days)}</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td className="text-right">R${data && MoneyMask(data.totalPrice, 2)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="block block-fx-pop block-bordered border-info mt-5">
                            <div className="block-header">
                                {data && processStatus()}
                                <div className="block-tools">
                                    {/* <button
                                //   onClick={() => setShowBusinessModal(true)}
                                className="btn btn-hero-info btn-sm"
                                >
                                Clique aqui
                                </button> */}
                                </div>
                            </div>
                        </div>
                        {schedule && schedule.date != undefined ?
                            <div className="block block-fx-pop block-bordered border-info mt-5">
                                <div className="block-header">
                                    <div className="block-title">
                                        Coleta agendada:
                                    </div>
                                    <div className="block-tools">
                                        <div className="form-group" >
                                            <span>Motivo do cancelamento</span>
                                            <select className="form-control" name="cancelationCode" onChange={evt => handleChange(evt)}>
                                                <option>Selecione</option>
                                                {DeliveryHelper().CancelationMotives.map(item => (
                                                    <option value={item.code}>{item.description}</option>
                                                ))}
                                            </select>
                                            <button className="btn btn-danger btn-sm" onClick={() => removeSchedule()}>Excluir agendamento</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="block-content">
                                    <div className="form-group">
                                        <span className="mr-2">{Translate(Message.CollectionDate)}</span>
                                        {schedule && OnlyDateTranslate(schedule.date)}
                                    </div>
                                    <div className="form-group">
                                        <span className="mr-2">{Translate(Message.CollectionInitialTime)}</span>
                                        {schedule && schedule.inicial_time}
                                    </div>
                                    <div className="form-group">
                                        <span className="mr-2">{Translate(Message.CollectionFinalTime)}</span>
                                        {schedule && schedule.final_time}
                                    </div>
                                    <div className="form-group">
                                        <span className="mr-2">{Translate(Message.CollectionInstructions)}</span>
                                        {schedule && schedule.instruction}
                                    </div>
                                </div>
                            </div>
                            : ""}
                        {docs && docs.length > 0 && data && data.id && DeliveryHelper().IsNational(data, "BR") == false && schedule.date == undefined ?
                            <div className="block block-rounded block-bordered border-info">
                                <div className="block-header">
                                    <div className="block-title">{Translate(Message.CollectionInstructions)}
                                    </div>
                                </div>
                                <div className="block-content">
                                    <div className="form-group">
                                        <span>{Translate(Message.CollectionDate)}</span>
                                        <input type="date" className="form-control" name="collectionDate" value={data && data.collectionDate} onChange={evt => handleChange(evt, FieldTypeObj.Date)} />
                                    </div>
                                    <div className="form-group">
                                        <span>{Translate(Message.CollectionInitialTime)}</span>
                                        <input type="time" className="form-control" name="initial_time" value={data && data.initial_time} onChange={evt => handleChange(evt)} />
                                    </div>
                                    <div className="form-group">
                                        <span>{Translate(Message.CollectionFinalTime)}</span>
                                        <input type="time" className="form-control" name="final_time" value={data && data.final_time} onChange={evt => handleChange(evt)} />
                                    </div>
                                    <div className="form-group">
                                        <span>{Translate(Message.CollectionInstructions)}</span>
                                        <textarea className="form-control" name="instruction" value={data && data.instruction} onChange={evt => handleChange(evt)} />
                                    </div>
                                    <button className="btn btn-success btn-block mt-3 mt-2" onClick={() => saveSchedule()}>{Translate(Message.Save)}</button>
                                </div>
                            </div>
                            : ""}
                    </div>
                </Panel>
                <Panel>
                    <ul class="timeline timeline-alt mt-0 mb-0 ml-5 mr-5">
                        {timeline && timeline.map(item => (
                            <li className="timeline-event">
                                <div class="media">
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                            <i className="fa fa-shipping-fast" />
                                        </span>
                                    </div>
                                    <div className="media-body ml-2 mb-3 mt-2 row">
                                        <span className="col-6">
                                            {item && item.description}
                                        </span>
                                        <span className="col-6 text-right">
                                            {item && DateTranslate(item.createdAt)}
                                        </span>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Panel>
            </Tabs>
        </Modal>
    );
}
